import { createSlice, createSelector } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { filter, mergeMap, map, takeUntil, catchError } from "rxjs/operators";
import { fromWebSocket } from "../websockets/centrifuge.js";
import { WSNamespaces } from "../websockets/ws-client.js";
const PUBLIC_WS_CONNECTION_STORE_FEATURE_KEY = "publicWsConnection";
const initialPublicWsConnectionSliceState = {
  channels: [],
  handlers: {},
  connected: false
};
const publicWsConnectionSlice = createSlice({
  name: PUBLIC_WS_CONNECTION_STORE_FEATURE_KEY,
  initialState: initialPublicWsConnectionSliceState,
  reducers: {
    addAliveChannels: (state, action) => {
      state.channels = [.../* @__PURE__ */ new Set([...state.channels, ...action.payload.channels])].sort((a, b) => a.length - b.length);
      state.handlers = action.payload.channels.reduce((p, c) => ({
        ...p,
        [c]: action.payload.handler
      }), state.handlers);
    },
    removeAliveChannels: (state, action) => {
      state.channels = state.channels.filter((el) => !action.payload.includes(el));
      action.payload.forEach((el) => {
        delete state.handlers[el];
      });
    },
    socketConnectionStart: (state) => {
      state.connected = true;
    },
    socketConnectionStop: (state) => {
      state.connected = false;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    socketConnectionFail: (state, _action) => {
      state.connected = false;
    }
  }
});
const publicWsConnectionReducer = publicWsConnectionSlice.reducer;
const {
  addAliveChannels,
  removeAliveChannels,
  socketConnectionStop,
  socketConnectionFail,
  socketConnectionStart
} = publicWsConnectionSlice.actions;
const getPublicWsConnectionStoreState = (rootState) => {
  return rootState[PUBLIC_WS_CONNECTION_STORE_FEATURE_KEY];
};
const selectPublicWsConnected = createSelector(
  getPublicWsConnectionStoreState,
  (s) => s.connected
);
const selectPublicWsConnectionAliveChannels = createSelector(
  getPublicWsConnectionStoreState,
  (s) => s.channels
);
const selectPublicWsConnectionChannelHandler = createSelector(
  getPublicWsConnectionStoreState,
  (_, channelName) => channelName,
  (s, channelName) => s.handlers[channelName]
);
const isBot = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /bot|crawl|spider|gmetrix|google|yandex|lighthouse|speed insights|pingdom/.test(ua);
};
const publicWsConnectionStartEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(socketConnectionStart.type),
  filter(() => !isBot()),
  mergeMap((action) => {
    var _a, _b;
    return fromWebSocket(
      {
        namespace: WSNamespaces.public,
        api: Api.wsClient,
        payload: (_a = action.payload) == null ? void 0 : _a.channels
      },
      void 0,
      {
        isProtoBuf: (_b = action.payload) == null ? void 0 : _b.isProtoBuf
      }
    ).pipe(
      map((data) => {
        const { channel, ...rest } = data;
        const result = { ...rest };
        result.type = result.event;
        const handler = selectPublicWsConnectionChannelHandler(state$.value, channel);
        return handler ? handler(result) : result;
      }),
      takeUntil(action$.pipe(ofType(socketConnectionStop.type))),
      catchError((err) => of(socketConnectionFail(err)))
    );
  })
);
const startPublicWsConnection = (payload) => ({
  type: socketConnectionStart.type,
  payload
});
const stopPublicWsConnection = () => ({
  type: socketConnectionStop.type
});
export {
  PUBLIC_WS_CONNECTION_STORE_FEATURE_KEY,
  addAliveChannels,
  getPublicWsConnectionStoreState,
  initialPublicWsConnectionSliceState,
  publicWsConnectionReducer,
  publicWsConnectionSlice,
  publicWsConnectionStartEpic,
  removeAliveChannels,
  selectPublicWsConnected,
  selectPublicWsConnectionAliveChannels,
  selectPublicWsConnectionChannelHandler,
  socketConnectionFail,
  socketConnectionStart,
  socketConnectionStop,
  startPublicWsConnection,
  stopPublicWsConnection
};
